import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../../dialogs/error-dialog/error-dialog.component';
import { Horario } from '../../../../util/hora-atendimeno';
import { Util } from '../../../../util/util';
import { ProcedimentoAgendaTomadaPk } from '../../pks/procedimento-agenda-tomada-pk';
import { ProcedimentoAgenda } from '../../procedimento-agenda';
import { ProcedimentoAgendaTomada } from '../../procedimento-agenda-tomada';

@Component({
  selector: 'app-cadastro-tomada',
  templateUrl: './cadastro-tomada.component.html',
  styleUrls: ['./cadastro-tomada.component.css']
})
export class CadastroTomadaComponent implements OnInit {

  procedimentoAgenda: ProcedimentoAgenda;

  formularioDeTomada: FormGroup;

  listaHorarios: Horario[] = Util.listaHorasAtendimentos;

  constructor(private router: Router, private formBuilder: FormBuilder,
    private dialog: MatDialog) {

    this.procedimentoAgenda = history.state.procedimentoAgenda;

    this.formularioDeTomada = this.formBuilder.group({
      horaTomada: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    if (!this.procedimentoAgenda) {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível cadastrar a Tomada. Procedimento Agenda não encontrado.'
        }
      });
    }
  }

  onSubmit() {
    this.save();
  }

  save() {

    if (!this.temTomadaCadastradaComEsteHorario()) {

      if (!this.procedimentoAgenda.tomadas) {
        this.procedimentoAgenda.tomadas = new Array<ProcedimentoAgendaTomada>();
      }

      const horaTomada: number = this.formularioDeTomada.value.horaTomada;

      const procAgendaTomada: ProcedimentoAgendaTomada = new ProcedimentoAgendaTomada();
      procAgendaTomada.pk = new ProcedimentoAgendaTomadaPk();
      procAgendaTomada.pk.idProcedimento = this.procedimentoAgenda.pk.idProcedimento;
      procAgendaTomada.pk.idMedico = this.procedimentoAgenda.pk.idMedico;
      procAgendaTomada.pk.diaSemana = this.procedimentoAgenda.pk.diaSemana;
      procAgendaTomada.pk.horaAtendimento = this.procedimentoAgenda.pk.horaAtendimento;
      procAgendaTomada.pk.horaTomada = horaTomada.toString();

      this.procedimentoAgenda.tomadas.push(procAgendaTomada);

      this.voltarPaginaAnterior();
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Essa Tomada já foi cadastrada!'
        }
      });
    }
  }

  temTomadaCadastradaComEsteHorario(): boolean {
    let existe: boolean = false;

    if (this.procedimentoAgenda && this.formularioDeTomada.value) {

      if (this.procedimentoAgenda.tomadas) {

        for (let tomadaAtual of this.procedimentoAgenda.tomadas) {
          if (tomadaAtual.pk.horaTomada === this.formularioDeTomada.value.horaTomada.toString()) {
            existe = true;
            break;
          }
        }
      }
    }

    return existe;
  }

  voltarPaginaAnterior(): void {
    this.router.navigate(['manterProcedimentoAgenda'], {
      state: {
        id: history.state.id,
        isUpdate: history.state.isUpdate,
        procedimentoAgenda: this.procedimentoAgenda,
        filtroProcedimentoAgenda: history.state.filtroProcedimentoAgenda,
      }
    });
  }
}
